import * as React from "react";
import { useTranslation } from "react-i18next";
import AuthenticationStore from "stores/AuthenticationStore";
import { FEATURE_FLAGS } from "types/globalTypes";

interface IProps {
  isLink?: boolean;
}

declare global {
  interface Window {
    embedded_svc?: any;
    embeddedservice_bootstrap?: any;
  }
}

function SalesForceChat({ isLink }: IProps) {
  const { t } = useTranslation();

  const openSalesforceChatWindow = () => {
    // AB #62557 / AB #62559 - when the flag is on, open the new Embedded
    // Messaging modal instead of the legacy Live Agent chat.
    if (AuthenticationStore.getFeatureFlag(FEATURE_FLAGS.CHAT_MIGRATION)) {
      if (window.embeddedservice_bootstrap?.utilAPI?.launchChat) {
        window.embeddedservice_bootstrap.utilAPI.launchChat();
      }
      return;
    }

    const element: HTMLElement = document.getElementsByClassName(
      "helpButtonEnabled",
    )[0] as HTMLElement;
    element?.click();
  };

  const renderButton = (isLink: boolean) => {
    if (isLink) {
      // link
      return (
        <a onClick={() => openSalesforceChatWindow()} id="chat-button">
          {t("contact.chatSupportLink")}
        </a>
      );
    }

    // Button
    return (
      <div>
        <a
          className="ant-btn salesForceButton"
          onClick={() => openSalesforceChatWindow()}
          id="chat-button"
        >
          {t("contact.chatSupportButton")}
        </a>
      </div>
    );
  };

  return (
    <div
      className="centeredContent salesForceChat"
      style={{ paddingBottom: 10 }}
    >
      {renderButton(isLink)}
    </div>
  );
}

export default SalesForceChat;
